import { ExportSection } from '../types';
import { isNumberExportColumn } from './isNumberExportColumn';
import resolveDecimalPlacesIssue from './resolveDecimalPlacesIssue';

// Mirrors the hasExportableColumns gating: only columns that actually reach the file can block the export.
const hasInvalidDecimalPlaces = (sections: ExportSection[]): boolean =>
  sections.some(
    (section) =>
      section.enabled &&
      section.columns.some(
        (column) =>
          column.selected &&
          isNumberExportColumn(column) &&
          resolveDecimalPlacesIssue(
            column.exportOptions.decimalPlaces,
            column.exportOptions.roundingMode
          ) !== null
      )
  );

export default hasInvalidDecimalPlaces;
